import ApiService from '@/services/ApiService';

const namespace = 'conversations';
const subNamespace = 'messages';

const find = (conversationId, id, options, callback, errorCallback) => {
    ApiService.get(`${namespace}/${conversationId}/${subNamespace}/${id}`, options, callback, errorCallback);
};

const findAll = (conversationId, options, callback, errorCallback) => {
    ApiService.get(`${namespace}/${conversationId}/${subNamespace}`, options, callback, errorCallback);
};

const create = (conversationId, data, callback, errorCallback) => {
    ApiService.post(`${namespace}/${conversationId}/${subNamespace}`, data, callback, errorCallback);
};

const update = (conversationId, id, data, callback, errorCallback) => {
    ApiService.put(`${namespace}/${conversationId}/${subNamespace}/${id}`, data, callback, errorCallback);
};

const remove = (conversationId, id, callback, errorCallback) => {
    ApiService.remove(`${namespace}/${conversationId}/${subNamespace}/${id}`, callback, errorCallback);
};

const read = (conversationId, id, callback, errorCallback) => {
    ApiService.put(`${namespace}/${conversationId}/${subNamespace}/${id}/read`, callback, errorCallback);
};

export default {
    find,
    findAll,
    create,
    update,
    remove,
    read,
};



// WEBPACK FOOTER //
// ./src/taskflex/conversations/services/MessageService.js